import { Injectable } from '@angular/core';
import { SLLayer, LayerAccessLevel } from '../model/sl-layer';
import { ModalMessagerService } from '../modal-messager/modal-messager.service';
import { AttributeInfo } from '../types/@types/sl-v-types';
import { csvFormat, csvFormatRows } from 'd3';
import { ColumnFormatter } from '../model/formatters/columnformatter';
import { Column } from 'angular-slickgrid';
import { NonBlockingIterator } from '../model/non-blocking-iterator';
import { Decorable } from '../types/decorable';
import { AttributesService } from '../model/api-services/attributes.service';

declare const Slick: any;

@Injectable({
	providedIn: 'root'
})
export class CsvExportService {

	constructor() { }

	static ExportData(messager: ModalMessagerService, columnDefs: Array<any>,
		layer: SLLayer, data: Array<any>, rawMode: boolean = false) {
		const attributes: Array<AttributeInfo> = layer.layerAttributes;
		const csvData = [];
		const attMap: any = {}
		const headerRow = [];
		
		const cols = (typeof columnDefs[0] === 'string') ? columnDefs : CsvExportService.GetVisibleColumnNames(columnDefs as Array<Column<any>>);
		for (const attribute of attributes) {
			if (!AttributesService.IsVisible(attribute)) {
				continue;
			}
			if (attribute.export) {
				if (attribute.export.allow === false) {
					continue;
				}
				if (attribute.export.reqAuth === true) {
					if (layer.access < LayerAccessLevel.Copy) {
						continue;
					}
				}
			}

			attMap[attribute.name] = attribute;
		}
		{
			for (const col of cols) {
				if (attMap[col]) {
					headerRow.push(attMap[col].display);
				}
			}
		}
		// csvData.push(headerRow);
		messager.Progress('Processing Data', false, 0, 'Exporting Data');
		const count = data.length;
		let output = csvFormatRows([headerRow]);

		const iterator = new NonBlockingIterator(data, (_result) => {
			messager.CancelProgress('Exporting Data');
			messager.RequestExport(
				{
					extension: 'csv', mimeType: 'text/csv',
					contents: '\ufeff' + output, defaultFileName: 'ResultsFrom_' + layer.name.replace(/ /g, '_')
				},
				'Export results as ...',
				() => {
					messager.Cancel('Export results as ...');
					messager.Notify('Your file has been saved');
				}, () => {
					messager.Cancel('Export resutls as ...');
					messager.Notify('There was an unknown problem saving your file', true, 'Problem Saving');
				}
			);
		}).ForEach((args: any) => {
			const item: any = args.item;
			if(item instanceof Slick.NonDataRow) {
				return;
			}
			const index: any = args.index;
			const itr8: NonBlockingIterator = args.itr8;
			const which = index + 1;
			messager.Progress(`Processing Data - Record ${which} of ${count}`, false, which/count , 'Exporting Data');
			const record = [];
			let cell = 1;
			for (const col of cols) {
				const attName = col;
				if (attMap.hasOwnProperty(attName)) {
					cell += 1;
					if (!item[attName]) {
						record.push('');
					} else {
						if (rawMode === true) {
							record.push(item[attName]);
						} else {
							record.push(ColumnFormatter.FormatText(item, attMap[attName]));
						}
					}
				}
			}
			output += '\r\n' + csvFormatRows([record]);
		});
		
	}
	static GetVisibleColumnNames(columnDefinitions: Array<Column<any>>): Array<string> {
		const cols: Array<string> = [];
		for (const def of columnDefinitions) {
			if (def.excludeFromColumnPicker || def.excludeFromExport) {
				continue;
			}
			const field = def.field;
			if (cols.indexOf(field) < 0) {
				cols.push(field);
			}

		}
		return cols;
	}

}
